/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Printer = [
  "svg",
  defaultAttributes,
  [
    ["polyline", { points: "6 9 6 2 18 2 18 9" }],
    ["path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" }],
    ["rect", { width: "12", height: "8", x: "6", y: "14" }]
  ]
];

export { Printer as default };
//# sourceMappingURL=printer.js.map
